import React from "react";
import { MdOutlineSubdirectoryArrowRight } from "react-icons/md";
import { RxCornerBottomLeft } from "react-icons/rx";

const FoodItem = ({ productImgSrc = null, title, options, quantity, price }) => {
  return (
    <li className="food">
      <div className="foodItem">
        <img
          src={imgHandler(productImgSrc)}
          alt={title}
          onError={(e) => (e.target.src = "/img/icon_function_3.png")}
        />
        <span className="tit">{title}</span>
      </div>
      <span className="foodQuantity">{quantity}</span>
      <span className="foodPrice">{formatNumber(price)}원</span>
      <ul className="options">
        {options &&
          options.length > 0 &&
          options.map((option, index) => (
            <li key={index}>
              <span>
                <i>
                  <RxCornerBottomLeft />
                </i>
                {option.optionName}
              </span>
              <span>{formatNumber(option?.optionPrice)}원</span>
            </li>
          ))}
      </ul>
    </li>
  );
};

export default FoodItem;
